import {
  REQUEST_ID_STORAGE_KEY,
  APP_URL_STORAGE_KEY,
} from './constants';
import uuid from 'react-native-uuid';

const parseQuery = value => {
  const search = value?.startsWith('?') ? value : `?${value || ''}`;
  const params = new URLSearchParams(search);
  const parsed = {};

  params.forEach((v, k) => {
    parsed[k] = v;
  });

  return parsed;
};

export const parseResponseUrlQuery = responseUrl => {
  try {
    if (!responseUrl) return {};

    const parsedUrl = new URL(responseUrl);
    return parseQuery(parsedUrl.search);
  } catch (_err) {
    return {};
  }
};

export const getIncomingAuthorizeParams = () => {
  let search = window.location.search;

  // Handle double-encoded query strings (e.g. ?response_type%3Dcode%26client_id%3D...)
  if (search && !search.includes('=') && search.includes('%3D')) {
    try {
      search = `?${decodeURIComponent(search.slice(1))}`;
    } catch (_err) {
      // fall through with original search
    }
  }

  return parseQuery(search);
};

export const generateRequestId = () => {
  
  return `id-txtsso-${uuid.v4()}`;
};

export const persistRequestId = requestId => {
  sessionStorage.setItem(REQUEST_ID_STORAGE_KEY, requestId);
};

export const retrieveRequestId = () => {
  return sessionStorage.getItem(REQUEST_ID_STORAGE_KEY);
};

export const getOrCreateRequestId = () => {
  const newId = generateRequestId();
  persistRequestId(newId);
  return newId;
};

export const persistAppUrl = appUrl => {
  if (appUrl) {
    sessionStorage.setItem(APP_URL_STORAGE_KEY, appUrl);
  }
};

export const retrieveAppUrl = () => {
  return sessionStorage.getItem(APP_URL_STORAGE_KEY);
};

export const clearAuthSession = () => {
  sessionStorage.removeItem(REQUEST_ID_STORAGE_KEY);
  sessionStorage.removeItem(APP_URL_STORAGE_KEY);
};

export const extractAgencyId = (clientId) => {
  if (!clientId) return '';
  const parts = clientId.split('-');
  return parts.length > 1 ? parts[0] : '';
};

export const extractAgencyIdFromSaml = (spEntityID) => {
  if (!spEntityID) return '';
  
  // If it contains "urn:", split by ":" and take the second part
  if (spEntityID.includes('urn:')) {
    const parts = spEntityID.split(':');
    return parts[1] || '';
  }
  
  // Otherwise split by "-" and take the first part
  const parts = spEntityID.split('-');
  return parts[0] || '';
};
